module.exports = __webpack_public_path__ + "img/calendar-icon--black.aaf0c44e.svg";